import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DashboardCategoriesModel } from '../../../core/models/user/dashboard-categories.model';
import { UserSessionModel } from '../../../core/models/user/current-user.model';
import { AuthService } from '../../../core/services/user/auth.service';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  categories: DashboardCategoriesModel[] = [];
  currentUser: UserSessionModel | null = null;
  userLang: string = '';
  forgotPasswordForm: { email: string; selectedLanguageCode: string };
  constructor(
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private toastService: ToastService
  ) {
    this.userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(this.userLang);
    
    this.forgotPasswordForm = {
      email: '',
      selectedLanguageCode: this.userLang,
    };
  }

  sendResetCode: boolean = false;
  currentYear: number = new Date().getFullYear();

  submitForgotPassword(e: Event): void {
    e.preventDefault();
    this.authService.forgotPassword(this.forgotPasswordForm).subscribe({
      next: () => {
        this.toastService.showToast(
          this.translate.instant('forgotPassword.eMailSendSuccessful'),
          'success'
        );

        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      },
    });
  }
}
